// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__r8HMg","shimmer":"SearchBar_shimmer__LeOH8"};